import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoaderState } from 'src/app/modules/core/enums/loader-state';
import { LoaderService } from 'src/app/modules/core/services/loader.service';
import { Loader } from '../../../core/classes/loader';
import { Subscription } from 'rxjs';

@Component({
	selector: 'cfe-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
	@Input() loader: Loader;

	showLoader: boolean;

	private subscription = new Subscription();

	constructor(private loadingService: LoaderService) {}

	ngOnInit(): void {
		let loader: Loader;
		if (this.loader) {
			loader = this.loader;
		} else {
			loader = this.loadingService.loader;
		}

		this.subscription.add(loader.getStateObservable().subscribe((state: LoaderState) => {
			this.showLoader = state === LoaderState.LOADING;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
